<!-- wrapper -->
<div class="wrapper">
	<nav class="navbar navbar-expand-lg navbar-light bg-white rounded fixed-top rounded-0 shadow-sm">
		<div class="container-fluid">
			<a class="navbar-brand" href="#">
				<img src="assets/images/logo-img.png" width="140" alt="" />
			</a>
			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent1" aria-controls="navbarSupportedContent1" aria-expanded="false" aria-label="Toggle navigation"> <span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarSupportedContent1">
				<ul class="navbar-nav ms-auto mb-2 mb-lg-0">
					<li class="nav-item"> <a class="nav-link active" aria-current="page" href="#"><i class='bx bx-home-alt me-1'></i>Home</a>
					</li>
					<li class="nav-item"> <a class="nav-link" href="#"><i class='bx bx-user me-1'></i>About</a>
					</li>
					<li class="nav-item"> <a class="nav-link" href="#"><i class='bx bx-category-alt me-1'></i>Features</a>
					</li>
					<li class="nav-item"> <a class="nav-link" href="#"><i class='bx bx-microphone me-1'></i>Contact</a>
					</li>
				</ul>
			</div>
		</div>
	</nav>
	<div class="error-404 d-flex align-items-center justify-content-center">
		<div class="container">
			<div class="card">
				<div class="row g-0">
					<div class="col-xl-5">
						<div class="card-body p-4">
							<h1 class="display-1"><span class="text-warning">5</span><span class="text-danger">0</span><span class="text-primary">0</span></h1>
							<h2 class="font-weight-bold display-4">Sorry, unexpected error</h2>
							<p>Looks like you are lost!
								<br>May be you are not connected to the internet!</p>
							<div class="mt-5">	<a routerLink="/" class="btn btn-lg btn-primary px-md-5 radius-30">Go Home</a>
								<a href="#" (click)="$event.preventDefault()" class="btn btn-lg btn-outline-dark ms-3 px-md-5 radius-30">Back</a>
							</div>
						</div>
					</div>
					<div class="col-xl-7">
						<img src="assets/images/errors-images/505-error.png" class="img-fluid" alt="">
					</div>
				</div>
				<!--end row-->
			</div>
		</div>
	</div>
	<div class="bg-white p-3 fixed-bottom border-top shadow">
		<div class="d-flex align-items-center justify-content-between flex-wrap">
			<ul class="list-inline mb-0">
				<li class="list-inline-item">Follow Us :</li>
				<li class="list-inline-item"><a href="#" (click)="$event.preventDefault()"><i class='bx bxl-facebook me-1'></i>Facebook</a>
				</li>
				<li class="list-inline-item"><a href="#" (click)="$event.preventDefault()"><i class='bx bxl-twitter me-1'></i>Twitter</a>
				</li>
				<li class="list-inline-item"><a href="#" (click)="$event.preventDefault()"><i class='bx bxl-google me-1'></i>Google</a>
				</li>
			</ul>
			<p class="mb-0">Copyright © 2021. All right reserved.</p>
		</div>
	</div>
</div>
<!-- end wrapper -->